import 'view/css/mg-customer.css';

import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Loading from 'component/Loading';
import PopMessage from 'component/pop-msg/PopMessage';

import SearchCustomerTable from 'component/SearchCustomerTable';

const MergeCustView = (props) => {

  const [loading, setLoading] = useState(false);

  const [sr_name, setSearchCustomerName] = useState('');
  const [sr_contact, setSearchContact] = useState('');
  const [sr_license, setSearchLicense] = useState('');
  const [sr_cust_rslt, setSearchResult] = useState(null);

  const [merge_list, setMergeList] = useState([]);

  const addItem = (cust) =>
  {
    for (let i = 0; i < merge_list.length; i++)
    {
      if (merge_list[i].id == cust.id)
        return false;
    }
    setMergeList([...merge_list, cust]);
  }
  const removeAt = (i) =>
  {
    let arr = Array.from(merge_list);
    arr.splice(i, 1);
    setMergeList(arr);
  }

  const search = () =>
  {
    setLoading(true);
    let dto = {
      name: sr_name,
      contact: sr_contact,
      license: sr_license,
    };
    API.searchCustomer(dto).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '失敗', 'danger');
      else {
        setSearchResult(resp.msg);
      }
      setLoading(false);
    });
  }

  const confirmMerge = () =>
  {
    if (window.confirm('此操作將無法復原，確定要合拼這些客戶？'))
    {
      setLoading(true);
      let ids = merge_list.map(x => x.id);
      API.mergeCustomers(ids).then(resp => {
        if (!resp.success)
          PopMessage.show(resp.msg, '存取失敗', 'danger');
        else
        {
          PopMessage.show('成功合拼客戶', '成功', 'success');
          setMergeList([]);
          setSearchResult(null);
        }
        setLoading(false);
      });
    }
  }

  return (<>
    <h1>其他管理 - 合拼客戶</h1>
    <div className="merge-cust-view">
      { !!merge_list?.length &&
        <div className="mg-list box">
          <h4 className="box-head">選取客戶</h4>
          <div className="box-body">
            <table>
              <colgroup>
                <col width="24px" />
                <col width="60px" />
                <col width="auto" />
                <col width="100px" />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th>編號</th>
                  <th>名稱</th>
                  <th>車輛</th>
                </tr>
              </thead>
              <tbody>
                { merge_list.map((x,i) =>
                  <tr key={x.id}>
                    <td>
                      <button className="btn small red" onClick={e=>removeAt(i)}>
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </td>
                    <td>{ x.id }</td>
                    <td>{ x.display_name }</td>
                    <td>
                      { x.vehicles.map(v =>
                        <div key={v.cd_license}>{ v.cd_license }</div>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="action-panel">
              <span className="dummy"></span>
              { merge_list.length > 1 &&
                <button className="btn red" onClick={confirmMerge}>確定合拼</button>
              }
            </div>
          </div>
        </div>
      }
      <div className="mg-search box">
        <h4 className="box-head">搜尋客戶</h4>
        <div className="box-body">
          <div className="action-panel">
            <div className="row">
              <label className="field">
                <strong>客戶名稱</strong>
                <input type="text" value={sr_name} onChange={e=>setSearchCustomerName(e.target.value)} />
              </label>
              <label className="field">
                <strong>電話或電郵</strong>
                <input type="text" value={sr_contact} onChange={e=>setSearchContact(e.target.value)} />
              </label>
              <label className="field">
                <strong>車牌</strong>
                <input type="text" value={sr_license} onChange={e=>setSearchLicense(e.target.value)} />
              </label>
            </div>
            <div>
              <button className="btn blue" onClick={search}>搜尋</button>
            </div>
          </div>
          <div>
          { loading
            ? <Loading />
            : <SearchCustomerTable text="加入"
                items={sr_cust_rslt} onSelect={addItem}/>
          }
          </div>
        </div>
      </div>
    </div>
  </>);

}

export default MergeCustView;

